import React, { useEffect } from 'react';
import Header from '../../../headerone/Main';
import Bredcom from '../../../Bredcom/Main';
import DrivingTestsDetails from '../../subdepartmentdetails/DrivingTests';

function DrivingTests() {
  useEffect(() => {
    document.getElementById("title").innerHTML = "Driving Tests || Motor Vehicles";
  }, []);

  return (
    <>
      {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

      <div className="page-wrapper">
        <Bredcom 
          subtitle="Motor Vehicles"
          title="Driving Tests"
          subtitledown="Department of Motor Vehicles"
        />
        <DrivingTestsDetails />
      </div>
    </>
  );
}

export default DrivingTests;
